import { useMutation, useQueryClient } from '@tanstack/react-query';
import { BASE_API_URL } from '../consts/base-url';
import type { BatchStatusT, BatchT } from '../types/batch';
import customFetch from '../utils/fetch';
export const useUpdateBatch = () => {
  const queryClient = useQueryClient();
  const {
    mutate,
    data,
    isPending,
    isSuccess,
    isError,
    error
  } = useMutation({
    mutationKey: ['updateBatch'],
    mutationFn: async ({
      batchId,
      priority
    }: {
      batchId: number;
      priority: number;
    }) => {
      if (batchId === null || priority === null) {
        throw new Error('Batch ID and priority are required');
      }
      const response = await customFetch(`${BASE_API_URL}/batch/${batchId}`, {
        method: 'PATCH',
        body: JSON.stringify({
          priority
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const {
        success,
        error,
        data
      } = (await response.json() as {
        success: boolean;
        error: string;
        data: BatchT;
      });
      if (!response.ok || !success) {
        throw new Error(`Failed on update batch request: ${error}`);
      }
      queryClient.setQueryData(['getBatchInProject', data.projectId], (oldData: BatchStatusT[]) => {
        return oldData.map(batch => batch.batchId === batchId ? {
          ...batch,
          ...data
        } : batch);
      });
      return {
        data
      };
    }
  });
  return {
    updateBatch: mutate,
    actionStatus: data,
    isPending,
    isSuccess,
    isError,
    error
  };
};